import React from 'react';

const NotFound = (props) => <h1>404.. This page is not found!</h1>

export default NotFound;


// WEBPACK FOOTER //
// ./src/scenes/NotFound/NotFound.component.js